import React, { createContext, useContext } from "react";

export const ImpersonationContext = createContext(null);

export const ImpersonationProvider = ({ children, trueUser, currentUser }) => {
  return (
    <ImpersonationContext.Provider value={{ trueUser, currentUser }}>
      {children}
    </ImpersonationContext.Provider>
  );
};

export const useImpersonation = () => {
  return useContext(ImpersonationContext);
};
